var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5102 34.3C10.8107 34 9.47216 14.6333 23.5102 13.7333V0C-6.94908 0.966667 -8.712 46.2 23.5102 48V34.3Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4898 13.7C36.1893 14 37.5278 33.3667 23.4898 34.2667L23.4898 48C53.9491 47.0333 55.712 1.8 23.4898 2.05533e-06L23.4898 13.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5102 34.3C58.8107 34 57.4722 14.6333 71.5102 13.7333V0C41.0509 0.966667 39.288 46.2 71.5102 48V34.3Z",
    fill: "#FE6571"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordList);
export default __webpack_public_path__ + "static/media/word-list.b0046afd2cbab4ef859c84a8fdd4c3a8.svg";
export { ForwardRef as ReactComponent };